import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import PaymentMethods from '../../components/PaymnetMethods/PaymentMethods';
import branchEditStore from '../../store/branchEditStore';
import { IBranchPaymentTypeOption } from '../../types/branchEdit';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';

const DineInPaymentMethods: FC = observer((): JSX.Element => {
  const onChangePaymentTypes = useCallback((paymentTypes: IBranchPaymentTypeOption[]) => {
    branchEditStore.changeDineInPaymentTypes(paymentTypes);
  }, []);

  return (
    <div className="w-25">
      <div className="d-flex align-items-center mb-4">
        <Text
          type={TEXT.SECTION_HEADER}
          text="payment_method"
          required
          tooltip={{ message: 'pay_method_default_infotip', position: TOOLTIP_POSITION.FIXED, iconSize: 20 }}
        />
      </div>

      <PaymentMethods
        paymentTypes={branchEditStore.dineInPaymentTypes}
        isValid={branchEditStore.validation.dineIn.paymentTypes}
        onChange={onChangePaymentTypes}
      />
    </div>
  );
});

export default DineInPaymentMethods;
